module.exports = __webpack_public_path__ + "img/appAsset--webhooks-ax.f520d5fb.svg";